
define('template!customerProfileTabTpl', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="well customer-profile">\n  <h1>' +
((__t = ( _.i18n('customerDetail.profile.title') )) == null ? '' : __t) +
'</h1>\n  <hr class="well-separator"/>\n  <div class="detailed-info-form-container">\n    <div class="row">\n      <div class="col-md-6">\n        <div class="col-xs-4">' +
((__t = ( _.i18n('common.name') )) == null ? '' : __t) +
'</div>\n        <div class="col-xs-8">' +
((__t = ( name ? name : '-' )) == null ? '' : __t) +
'</div>\n      </div>\n      <div class="col-md-6">\n        <div class="col-xs-4">' +
((__t = ( _.i18n('common.endUserId') )) == null ? '' : __t) +
'</div>\n        <div class="col-xs-8">' +
((__t = ( endUserId ? endUserId : '-' )) == null ? '' : __t) +
'</div>\n      </div>\n    </div>\n    <div class="row">\n      <div class="col-md-6">\n        <div class="col-xs-4">' +
((__t = ( _.i18n('common.first.name') )) == null ? '' : __t) +
'</div>\n        <div class="col-xs-8">' +
((__t = ( firstName ? firstName : '-' )) == null ? '' : __t) +
'</div>\n      </div>\n      <div class="col-md-6">\n        <div class="col-xs-4">' +
((__t = ( _.i18n('common.last.name') )) == null ? '' : __t) +
'</div>\n        <div class="col-xs-8">' +
((__t = ( lastName ? lastName : '-' )) == null ? '' : __t) +
'</div>\n      </div>\n    </div>\n    <div class="row">\n      <div class="col-md-6">\n        <div class="col-xs-4">' +
((__t = ( _.i18n('common.workName') )) == null ? '' : __t) +
'</div>\n        <div class="col-xs-8">' +
((__t = ( workName ? workName : '-' )) == null ? '' : __t) +
'</div>\n      </div>\n      <div class="col-md-6">\n        <div class="col-xs-4">' +
((__t = ( _.i18n('endUsersDetail.language') )) == null ? '' : __t) +
'</div>\n        <div class="col-xs-8">' +
((__t = ( locales ? locales : '-' )) == null ? '' : __t) +
'</div>\n      </div>\n    </div>\n    <div class="row">\n      <div class="col-md-6">\n        <div class="col-xs-4">' +
((__t = ( _.i18n('common.addressL1') )) == null ? '' : __t) +
'</div>\n        <div class="col-xs-8">' +
((__t = ( addressL1 ? addressL1 : '-' )) == null ? '' : __t) +
'</div>\n      </div>\n      <div class="col-md-6">\n        <div class="col-xs-4">' +
((__t = ( _.i18n('common.addressL2') )) == null ? '' : __t) +
'</div>\n        <div class="col-xs-8">' +
((__t = ( addressL2 ? addressL2 : '-' )) == null ? '' : __t) +
'</div>\n      </div>\n    </div>\n    <div class="row">\n      <div class="col-md-6">\n        <div class="col-xs-4">' +
((__t = ( _.i18n('common.zip') )) == null ? '' : __t) +
' / ' +
((__t = ( _.i18n('common.city') )) == null ? '' : __t) +
'</div>\n        <div class="col-xs-8">' +
((__t = ( zip ? zip : '-' )) == null ? '' : __t) +
' / ' +
((__t = ( city ? city : '-' )) == null ? '' : __t) +
'</div>\n      </div>\n\n      <div class="col-md-6">\n        <div class="col-xs-4">' +
((__t = ( _.i18n('common.countryCode') )) == null ? '' : __t) +
'</div>\n        <div class="col-xs-8">' +
((__t = ( country ? country : '-' )) == null ? '' : __t) +
'</div>\n      </div>\n    </div>\n    <div class="row">\n      <div class="col-md-6">\n        <div class="col-xs-4">' +
((__t = ( _.i18n('common.email') )) == null ? '' : __t) +
'</div>\n        <div class="col-xs-8">' +
((__t = ( email ? email : '-' )) == null ? '' : __t) +
'</div>\n      </div>\n      <div class="col-md-6">\n        <div class="col-xs-4">' +
((__t = ( _.i18n('userInfo.emailCustomerService') )) == null ? '' : __t) +
'</div>\n        <div class="col-xs-8">' +
((__t = ( emailCustomerService ? emailCustomerService : '-' )) == null ? '' : __t) +
'</div>\n      </div>\n    </div>\n    <div class="row">\n      <div class="col-md-6">\n        <div class="col-xs-4">' +
((__t = ( _.i18n('common.webSite') )) == null ? '' : __t) +
'</div>\n        <div class="col-xs-8">' +
((__t = ( webSite ? webSite : '-' )) == null ? '' : __t) +
'</div>\n      </div>\n      <div class="col-md-6">\n        <div class="col-xs-4">' +
((__t = ( _.i18n('common.vatNumber') )) == null ? '' : __t) +
'</div>\n        <div class="col-xs-8">' +
((__t = ( vatNumber ? vatNumber : '-' )) == null ? '' : __t) +
'</div>\n      </div>\n    </div>\n    <div class="row">\n      <div class="col-md-6">\n        <div class="col-xs-4">' +
((__t = ( _.i18n('endUsersDetail.endUserComments') )) == null ? '' : __t) +
'</div>\n        <div class="col-xs-8">' +
((__t = ( comment ? comment : '-' )) == null ? '' : __t) +
'</div>\n      </div>\n      <div class="col-md-6">\n        <div class="col-xs-4">' +
((__t = ( _.i18n('endUsersDetail.companyNumber') )) == null ? '' : __t) +
'</div>\n        <div class="col-xs-8">' +
((__t = ( companyNumber ? companyNumber : '-' )) == null ? '' : __t) +
'</div>\n      </div>\n    </div>\n    <div class="row">\n      <div class="col-md-6">\n        <div class="col-xs-4">' +
((__t = ( _.i18n('endUsersDetail.priceList') )) == null ? '' : __t) +
'</div>\n        <div class="col-xs-8">' +
((__t = ( priceListCode ? priceListCode : '-' )) == null ? '' : __t) +
'</div>\n      </div>\n        <div class="col-md-6">\n            <div class="col-xs-4">' +
((__t = ( _.i18n('endUsersDetail.login') )) == null ? '' : __t) +
'</div>\n            <div class="col-xs-8">' +
((__t = ( login ? login : '-' )) == null ? '' : __t) +
'</div>\n        </div>\n    </div>\n    <div class="row">\n      <div class="pull-right p-r-15">\n        <button class="btn btn-primary js-edit">' +
((__t = ( _.i18n('common.edit') )) == null ? '' : __t) +
'</button>\n      </div>\n    </div>\n  </div>\n</div>';

}
return __p
};});

